<template>
  <router-view></router-view>
</template>

<script>
  export default {
      name: 'ApplicationLayout'
  }
</script>
